import styled from "styled-components";

export const MosaicWrapper = styled.div<{ width: string }>`
  display: flex;
  flex-direction: row;
  width: ${({ width }) => width || "100%"};
  height: auto;
  margin: 0 auto;
  gap: 10px;
  padding: 2rem 0;

  @media (max-width: 480px) {
    width: 100%;
    gap: 5px;
  }
`;

export const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
`;

export const RightWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Change to 2 columns */
  grid-gap: 10px; /* Add grid gap */
  width: 100%;
  height: auto;
  @media (max-width: 480px) {
    grid-gap: 5px; /* Add grid gap */
  }
`;

export const Image = styled.img<{ type?: string }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  padding: 5px;
  padding-top: 0;
  cursor: pointer;
  transition: filter 0.3s ease;

  &:hover {
    filter: brightness(0.8);
    cursor: pointer;
  }

  ${({ type }) =>
    type === "left" &&
    `
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    padding: 0 5px;

    @media (max-width: 768px) {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    @media (max-width: 480px) {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  `}

  ${({ type }) =>
    type === "top-right" &&
    `
    border-top-right-radius: 20px;

    @media (max-width: 768px) {
      border-top-right-radius: 10px;
    }

    @media (max-width: 480px) {
      border-top-right-radius: 5px;
    }
  `}

  ${({ type }) =>
    type === "bottom-right" &&
    `
    border-bottom-right-radius: 20px;

    @media (max-width: 768px) {
      border-bottom-right-radius: 10px;
    }

    @media (max-width: 480px) {
      border-bottom-right-radius: 5px;
    }
  `}

//   @media (max-width: 768px) {
//     padding: 5px;
//   }

//   @media (max-width: 480px) {
//     padding: 2px;
//   }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const OverlayContent = styled.div<{ fitToScreen: boolean }>`
  max-width: 90%;
  max-height: 90%;
  overflow: hidden;
  opacity: 0;
  animation: fade-in 0.3s ease-in-out forwards;
  object-position: center center;

  img {
    width: ${(props) => (props.fitToScreen ? "100%" : "auto")};
    height: ${(props) => (props.fitToScreen ? "100%" : "auto")};
    max-width: ${(props) => (props.fitToScreen ? "none" : "100%")};
    max-height: ${(props) => (props.fitToScreen ? "none" : "100%")};
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
